require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-visualizing-the-history-of-node-js-via-git-commits.json") })
        }
      }, "path---blog-visualizing-the-history-of-node-js-via-git-commits");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-visualizing-the-history-of-node-js-via-git-commits!./.cache/json/blog-visualizing-the-history-of-node-js-via-git-commits.json
// module id = 1116
// module chunks = 231608221292675